import React, { useRef } from "react";
import { Toast } from "primereact/toast";
import styles from "./ProductGrid.module.css";
import ProductCard, { Product } from "../ProductCard/ProductCard";
import { ProgressSpinner } from "primereact/progressspinner";
import noProductFoundImage from "../../../assets/images/product-not-found.png";
import { Image } from "react-bootstrap";
interface ProductGridProps {
  products: Product[];
  code?: string;
  loadingMore?: boolean;
}

const ProductGrid: React.FC<ProductGridProps> = ({
  products,
  code = "TYRE",
  loadingMore = false,
}) => {
  const toast = useRef<Toast>(null);

  // While a fetch is in flight, don't show "no results" yet —
  // we don't know the real outcome until loading finishes.
  if (products.length === 0 && loadingMore) {
    return null; // parent's <AppSkeleton /> is already showing
  }

  if (products.length === 0 && !loadingMore) {
    return (
      <div
        className={styles.empty}
        style={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Image
            src={noProductFoundImage}
            alt="No Product Found"
            width={"200"}
            height={"200"}
            className="no-products-image"
          />
        </div>
        <div>
          <p className={styles.emptyText}>
            No{" "}
            {code === "BATTERY"
              ? "batteries"
              : code === "TYRE"
                ? "tyres"
                : "Accessories"}{" "}
            found matching your filters.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Toast ref={toast} />
      <div className={styles.grid}>
        {products.map((product) => (
          <ProductCard
            key={product.product_id}
            product={product}
            toastRef={toast}
            code={code}
          />
        ))}
      </div>
    </>
  );
};

export default ProductGrid;
